module.exports = __webpack_public_path__ + "img/98.1a13481.png";